import request from '@/utils/requestnew'
import baseUrl from './baseUrl'

const BASE_URL = baseUrl + '/frmarket'

export default {

    //上传文件
    uploadDouyingoodsdetail(params){
        return request({
            url: BASE_URL + '/uploadDouyingoodsdetail',
            method: 'post',
            params
        })
    },

    //上传文件
    uploadDouyintab(params){
        return request({
            url: BASE_URL + '/uploadDouyintab',
            method: 'post',
            params
        })
    },

    //上传文件
    uploadJdgoodsdetail(params){
        return request({
            url: BASE_URL + '/uploadJdgoodsdetail',
            method: 'post',
            params
        })
    },
    //上传文件
    uploadJdhotsearch(params){
        return request({
            url: BASE_URL + '/uploadJdhotsearch',
            method: 'post',
            params
        })
    },
    //上传文件
    uploadRedbooktab(params){
        return request({
            url: BASE_URL + '/uploadRedbooktab',
            method: 'post',
            params
        })
    },
    //上传文件
    uploadTmallexchangetop(params){
        return request({
            url: BASE_URL + '/uploadTmallexchangetop',
            method: 'post',
            params
        })
    },
    //上传文件
    uploadTmallJieyu(params){
        return request({
            url: BASE_URL + '/uploadTmallJieyu',
            method: 'post',
            params
        })
    },
    //上传文件
    uploadWeibotab(params){
        return request({
            url: BASE_URL + '/uploadWeibotab',
            method: 'post',
            params
        })
    },
    //上传文件
    uploadWeixintab(params){
        return request({
            url: BASE_URL + '/uploadWeixintab',
            method: 'post',
            params
        })
    },

    //上传文件
    uploadYouzan(params){
        return request({
            url: BASE_URL + '/uploadYouzan',
            method: 'post',
            params
        })
    },

    //上传文件
    uploadZhihuinfotab(params){
        return request({
            url: BASE_URL + '/uploadZhihuinfotab',
            method: 'post',
            params
        })
    },

    //上传文件
    uploadZhihutab(params){
        return request({
            url: BASE_URL + '/uploadZhihutab',
            method: 'post',
            params
        })
    },

    //下载模板
    downloadTem(params) {
        return request({
            url: BASE_URL + `/downloadTem/${params}`,
            method: 'get',
            responseType: 'blob',
            params,
        })
    }
}